import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { __rest as t } from "../_virtual/_tslib.js";
import { jsxs as n, jsx as i } from "react/jsx-runtime";
import { calculateRem as e } from "@vds-core/utilities";
import { LayoutTokens as a } from "@vds-tokens/layout";
import { forwardRef as r } from "react";
import o from "styled-components";
import s from "./Button.js";
import c from "./TextLink.js";
import u from "./TextLinkCaret.js";
var d = function d(t) {
    return a.space[t].value;
  },
  l = o.div.withConfig({
    displayName: "ButtonWrapper",
    componentId: "VDS__sc-1ykjn9v-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  box-sizing: border-box;\n  outline: none;\n  ", ";\n"])), function (t) {
    return function (t) {
      var n = t.size,
        i = t.use,
        a = t.$nextButtonType,
        r = t.$rowQuantity,
        o = t.$calculateButtonSpacing,
        s = t.$isButton,
        c = t.$groupWidth,
        _o = o(n, i, a),
        u = _o.topSpacing,
        l = _o.rightSpacing,
        p = _o.bottomSpacing,
        $ = u ? d(u) : "0",
        m = d(p);
      var f,
        g,
        h = 0 === l ? "0px" : d(l);
      return f = "small" === n ? 54 : 76, 1 === r && "small" !== n && (h = "0px"), g = r ? "\n      display: flex;\n      align-items: center;\n      padding-right: ".concat(e(h), ";\n      flex-shrink: 1;\n      flex-grow: ").concat(s && "100%" === c ? 1 : 0, ";\n      flex-basis: ").concat(s ? "calc(".concat(c, " + ").concat(h, ")") : "auto", ";\n      min-width: ").concat(s && e(f + parseInt(h, 10)), ";\n    ") : "\n      display: inline-block;\n      padding-top: ".concat(e($), ";\n      padding-bottom: ").concat(e(m), ";\n      padding-right: ").concat(e(h), ";\n      min-width: ").concat(s && e(f + parseInt(h, 10)), ";\n      width: ").concat(s && "auto" === c ? "auto" : "calc(".concat(c, " + ").concat(h, ")"), ";\n    "), g;
    }(t);
  }, function (_ref) {
    var t = _ref.$noVerticalPadding;
    return t && "\n    padding-bottom: 0px;\n  ";
  }),
  p = function p(t, n) {
    var e = t.use,
      a = t.children,
      r = t.size,
      o = t.width,
      c = t.dataLoc,
      u = t.surface,
      d = t.ariaLabel;
    return "primary" === e ? i(s, Object.assign({}, t, {
      buttonRef: n,
      style: {
        maxWidth: "100%"
      },
      ariaLabel: d,
      size: r,
      width: o || "100%",
      dataLoc: c,
      surface: u,
      children: a
    })) : "secondary" === e ? i(s, Object.assign({}, t, {
      buttonRef: n,
      use: "secondary",
      style: {
        maxWidth: "100%"
      },
      ariaLabel: d,
      size: r,
      width: o || "100%",
      dataLoc: c,
      surface: u,
      children: a
    })) : void 0;
  },
  $ = function $(t, n) {
    var e = t.use,
      a = t.size,
      r = t.surface,
      o = t["aria-label"] || t.ariaLabel;
    return "textLink" === e ? i("span", {
      children: i(c, Object.assign({}, t, {
        textLinkRef: n,
        style: {
          maxWidth: "100%"
        },
        ariaLabel: o,
        size: a,
        type: "standAlone",
        surface: r
      }))
    }) : "textLinkCaret" === e ? i(u, Object.assign({}, t, {
      textLinkCaretRef: n,
      style: {
        maxWidth: "100%"
      },
      ariaLabel: o,
      iconPosition: "right",
      surface: r
    })) : void 0;
  },
  m = r(function (i, e) {
    var a = i.$rowQuantity,
      r = i.size,
      o = i.use,
      s = i.$nextButtonType,
      c = i.width,
      u = i.$noVerticalPadding,
      d = i.$calculateButtonSpacing,
      m = i.$groupWidth,
      f = i.surface;
    t(i, ["$rowQuantity", "size", "use", "$nextButtonType", "width", "$noVerticalPadding", "$calculateButtonSpacing", "$groupWidth", "surface"]);
    return n(l, {
      $rowQuantity: a,
      size: r,
      use: o,
      $nextButtonType: s,
      width: c,
      $noVerticalPadding: u,
      $calculateButtonSpacing: d,
      $groupWidth: m,
      $isButton: "primary" === o || "secondary" === o,
      children: [p(i, e), $(i, e)]
    });
  });
m.defaultProps = {
  size: "large",
  use: "primary",
  $noVerticalPadding: !1
};
export { m as default };